// Portal home entry (/) — the long-page homepage. Self-contained visuals:
// loads src/home.css only (no index.css, no shared-ui tokens).
import { createRoot } from "react-dom/client";
import { HomePage } from "../pages/HomePage";

const rootEl = document.getElementById("root");
if (rootEl === null) {
  throw new Error("portal home entry: #root container missing in index.html");
}
createRoot(rootEl).render(<HomePage />);
